import Vue from "vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/ko";

/**
 * @param {Vue} Vue
 * @param {*} options
 */
const install = function(Vue, options) {
    Vue.prototype.$dayjs = dayjs;
    Vue.prototype.$dayjs.extend(utc);
    Vue.prototype.$dayjs.extend(timezone);
    Vue.prototype.$dayjs.locale("ko");
    Vue.prototype.$dayjs.tz.setDefault("Asia/Seoul");
};

Vue.use({ install });

export default dayjs;
